import { Helmet } from 'react-helmet';
import { useDashboardContext } from '@/contexts/DashboardContexProvider';
import DashboardManagerView from '@/components/Dashboard/DashboardManagerView';
import { AuthorityCodesDashboard } from '@/core/domain/enterprise/Authority/Authority.types';
import DashboardFinancialView from '@/components/Dashboard/DashboardFinancialView';
import DashboardDefaultView from '@/components/Dashboard/DashboardDefaultView';
import DashboardEstimatorView from '@/components/Dashboard/DashboardEstimatorView';
import Authorities, { AuthoritiesType } from '@/types/Authority';
import DashboardWelcomeView from '@/components/Dashboard/DashboardWelcomeView';
import { hasPermissions } from '@/utils/functions/hasPermissions';
import { useUserCurrent } from '@/core/domain/enterprise/Users/Users.hooks';
import { useEffect } from 'react';
import UserGuiding from '@/core/UserGuinding';

const DashboardPage = () => {
  const { dashboardType } = useDashboardContext();
  const userCurrent = useUserCurrent();

  useEffect(() => {
    const userProfile = userCurrent.data?.profiles[0];

    if (userProfile) {
      const isSystemAdmin =
        !!userProfile?.system &&
        userProfile.name.trim().toUpperCase() === 'ADMINISTRADOR';

      UserGuiding.showWelcomeGuid(isSystemAdmin);
    }
  }, [userCurrent.dataUpdatedAt]);

  function renderAccessDenied(type: AuthoritiesType) {
    return (component: React.ReactElement) => {
      if (!hasPermissions([type])) {
        return <DashboardWelcomeView />;
      }
      return component;
    };
  }

  return (
    <>
      <Helmet title="Dashboard" />
      {dashboardType === AuthorityCodesDashboard.managerView &&
        renderAccessDenied(Authorities.DASHBOARD_VIEW_MANAGEMENT)(
          <DashboardManagerView />,
        )}
      {dashboardType === AuthorityCodesDashboard.financialView &&
        renderAccessDenied(Authorities.DASHBOARD_VIEW_FINANCEIRO)(
          <DashboardFinancialView />,
        )}
      {dashboardType === AuthorityCodesDashboard.defaultView &&
        renderAccessDenied(Authorities.DASHBOARD_VIEW_STANDARD)(
          <DashboardDefaultView />,
        )}
      {dashboardType === AuthorityCodesDashboard.estimatorView &&
        renderAccessDenied(Authorities.DASHBOARD_VIEW_BUDGET)(
          <DashboardEstimatorView />,
        )}
    </>
  );
};

export default DashboardPage;
